<div class="row">
  <div class="col-12">


    <h1>{{title}}</h1>
    <div class="mb-2">
      <re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>
    </div>
  </div>
  <div class="col-12">
    <div>{{description}}</div>
  </div>

  <div class="col-12 my-3">
    <a [routerLink]="['run']" class="btn btn-primary">{{title}}</a>
    <button class="ml-2 btn btn-default" (click)="load()">Refresh</button>
  </div>

  <div class="col-12">
    <table class="table table-striped table-hover table-bordered">
      <thead>
        <tr>
          <th>Customer Name</th>
          <th>CRMID</th>
          <th *ngIf="!columnsToIgnoreObject['environment']">Environment</th>
          <th *ngIf="!columnsToIgnoreObject['corporation']">Corporation</th>
          <th>User Count</th>
          <th *ngIf="!columnsToIgnoreObject['download']">Val. Success Count</th>
          <th *ngIf="!columnsToIgnoreObject['download']">Val. Error Count</th>
          <th>{{ columnsToIgnoreObject['download'] ? 'Success' : 'Created count'}}</th>
          <th>{{ columnsToIgnoreObject['download'] ? 'Failed' : 'Creation Error Count'}}</th>
          <th>Started By</th>
          <th>Started On</th>
          <th>Ended On</th>
          <th>Status</th>
          <th *ngIf="!columnsToIgnoreObject['download']">Output File</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td>{{item.customerName}}</td>
          <td>{{item.crmId}}</td>
          <td *ngIf="!columnsToIgnoreObject['environment']">{{item.environmentName}}</td>
          <td *ngIf="!columnsToIgnoreObject['corporation']">{{item.corporationName}}</td>
          <td>{{item.userCount}}</td>
          <td  *ngIf="!columnsToIgnoreObject['download']">{{ item.validationSuccessCount }}</td>
          <td  *ngIf="!columnsToIgnoreObject['download']">{{ item.validationErrorCount }}</td>
          <td>{{item.successCount}}</td>
          <td>{{item.failureCount}}</td>
          <td>{{item.startedBy}}</td>
          <td>{{item.startedDateTimeGMT|date:'short'}}</td>
          <td>{{item.endedDateTimeGMT|date:'short'}}</td>
          <td>
            <span [class.bg-danger]="hasErrors(item)" [class.text-white]="hasErrors(item)">{{getStatusText(item.status)}}</span>
            <span *ngIf="item.failureCount>0"><a class="ml-2" [routerLink]="['failedUsers',item.processId]">View Details</a></span>
          </td>
          <td><span *ngIf="!columnsToIgnoreObject['download']"><a class="ml-2" [routerLink]="[]" (click)="download(item)">Download</a></span></td>
        </tr>
      </tbody>
    </table>
  </div>


</div>
